import PasswordInvisibleIcon from "@/assets/C1C1D7_password_invisible_icon.svg?react";
import PasswordVisibleIcon from "@/assets/C1C1D7_password_visible_icon.svg?react";
import InputField from "@/components/Common/forms/InputField";
import {memo, type FC, type ReactNode} from "react";
import {useToggle} from "react-use";

const PasswordField: FC<{
  onChange: (value: string) => void;
  error: string | null | undefined;
  icon?: ReactNode;
  label?: string;
  value: string | null;
  placeholder?: string;
  className?: string;
  customFieldId?: string;
}> = ({onChange, error = null, label, placeholder, value, className, customFieldId}) => {
  const [isPasswordVisible, togglePasswordVisibility] = useToggle(false);

  return (
    <InputField
      customFieldId={customFieldId}
      onChange={onChange}
      className={className}
      error={error}
      value={value ?? ""}
      label={label}
      placeholder={placeholder}
      type={isPasswordVisible ? "text" : "password"}
      icon={
        <button onClick={togglePasswordVisibility} className="absolute top-0 right-0 bottom-0 h-full pr-4">
          {isPasswordVisible ? (
            <PasswordVisibleIcon className="size-5 shrink-0" />
          ) : (
            <PasswordInvisibleIcon className="size-5 shrink-0" />
          )}
        </button>
      }
    />
  );
};

export default memo(PasswordField);
